import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import routes from './Routes';

const SwitchRoutes = () => (
  <Router>
    <Routes>
      {routes.map((route) => (
        <Route key={route.path} path={route.path} element={route.main()} />
      ))}
    </Routes>
  </Router>
);

export default SwitchRoutes;
